/* eslint-disable */
import React from "react";

import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

const NurseDetailsCard = ({ nurse = {} }) => {
  return (
    <div className="p-3 border border-gray-300 rounded-8 shadow-sm">
      <div className="d-flex gap-3">
        <div
          className="avatar rounded-circle overflow-hidden"
          style={{
            width: "60px",
            height: "60px",
          }}
        >
          <img
            className="w-100 h-100 object-fit-cover"
            src={
              nurse?.image !== ""
                ? url.SERVER_URL + nurse?.image
                : assetImages.defaultUser
            }
            alt="patient"
          />
        </div>
        <div>
          <p className="mb-0">{nurse?.label}</p>
          <p className="font-sm text-gray mb-0">Email: {nurse?.email}</p>
          <p className="font-sm text-gray mb-0">Phone: {nurse?.phone}</p>
        </div>
      </div>
    </div>
  );
};

export default NurseDetailsCard;
